export const publications = [
    {
        title: "Transmission models of historical Ebola outbreaks",
        authors: "J. Drake, I. Bakach, S. O'Regan, M. Gambhir, I. Fung",
        subtitle: "Emerging Infectious Diseases",
        boldNumbers: "21(8)",
        year: "2015",
        pageNumbers: "1447-1450",
        link: ""
    },
    {
        title: "Typhoid transmission: a historical perspective on mathematical model development",
        authors: "I. Bakach, M. Gambhir, I. Fung",
        subtitle: "Transactions of the Royal Society of Tropical Medicine and Hygiene",
        boldNumbers: "109(11)",
        year: "2015",
        pageNumbers: "679-689",
        link: ""
    },
    {
        title: "Colored patterns and their packing densities",
        authors: "H. Wang",
        subtitle: "Cong. Numer.",
        boldNumbers: "225",
        year: "2015",
        pageNumbers: "23-28",
        link: "https://drive.google.com/file/d/1gYnzfP6GjkN3R6msFhxECBtBD7xNEJxD/view"
    },
    {
        title: "Note on packing patterns in colored permutations",
        authors: "H. Wang",
        subtitle: "Online J. Anal. Comb.",
        boldNumbers: "11",
        year: "2016",
        pageNumbers: "9 pp",
        link: "https://drive.google.com/file/d/1eM8MqohmUhDOfBI2XPP_ig2ftLPzU0RG/view"
    },
    {
        title: "The impact of shared sanitation facilities on diarrheal diseases with and without an environmental reservoir: a modeling study",
        authors: "S. Carden, S. Li, K. Baker, M. Gambhir, I. Fung",
        subtitle: "Pathogens and Public Health",
        boldNumbers: "112(4)",
        year: "2018",
        pageNumbers: "195-102",
        link: ""
    },
    {
        title: "Note on restricted parts in cyclic compositions",
        authors: "M. Gibson, H. Wang",
        subtitle: "Integers",
        boldNumbers: "18",
        year: "2018",
        pageNumbers: "13 pp",
        link: "http://math.colgate.edu/~integers/s19/s19.pdf"
    },
    {
        title: "On upper bounds for the count of elite primes",
        authors: "",
        subtitle: "Integers",
        boldNumbers: "20",
        year: "2020",
        pageNumbers: "5 pp",
        link: "https://arxiv.org/abs/2102.00906"
    },
    {
        title: "On factorizations into comprime parts",
        authors: "N. Lebowitz-Lockard",
        subtitle: "to appear in Int. J. Number Theory",
        boldNumbers: "",
        year: "",
        pageNumbers: "",
        link: "https://arxiv.org/abs/2102.00978"
    },
];


// WEBPACK FOOTER //
// ./src/data/publications.js